import { priorityLabels } from "@p0security/shared/assessment/constants";
import { MonitorBase } from "@p0security/shared/types/assessment/monitor";
import { Spacing } from "@p0security/ui";
import { priorityColor } from "components/Assessment/utils/monitor";
import { StyledTag } from "styles/StyledTags";
import { colors } from "styles/variables";

export const MonitorPriority: React.FC<{
  monitor: Pick<MonitorBase, "priority">;
}> = ({ monitor }) => (
  <Spacing asChild mr="0">
    <StyledTag
      color={priorityColor[monitor?.priority].tagColor ?? colors.tagColors.grey}
      /* eslint-disable-line react/forbid-component-props */ style={{
        width: "5em",
        textAlign: "center",
      }}
    >
      {priorityLabels[monitor.priority]}
    </StyledTag>
  </Spacing>
);
